import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Button from '../../shared/Button';
import DropSection from '../../shared/DropSection';
import styles from './styles.scss';
import SectionTitle from '../../shared/SectionTitle';
import SectionDescription from '../../shared/SectionDescription';

const Attachment = ({
  file,
  hasAttachment,
  attachmentDeleted,
  onUpload,
  onRemove,
  downloadAttachment,
  attachmentFilename,
}) => [
  <Col className={`${styles.infoSection}`} key="Attachment">
    <SectionTitle title="Attachment" />
    <SectionDescription
      description="Attached pdf will be appended to the report file. Limit 1 file (PDF only) - Max file size: 4 MB"
      key="description"
    />
    <Row className="mx-1 py-3" key="upload">
      <Col>
        <DropSection key="dropsection" accept=".pdf" onDrop={onUpload} />
      </Col>
      <Col>
        <div className="d-table w-100 h-100 text-center">
          <div className={`d-table-cell ${styles.preview}`}>
            <i className={`fa fa-file-pdf-o mb-2 ${styles.icon}`} />
            <br />
            <Choose>
              <When condition={file}>
                <a href={file.preview} className="d-inline-block" target="_blank" rel="noopener noreferrer">
                  {'Click to open file ' + file.name}
                </a>
              </When>
              <When condition={hasAttachment && !attachmentDeleted}>
                <a
                  href="#"
                  onClick={() => {
                    downloadAttachment().then((blob) => {
                      const link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.target = '_blank';
                      link.type = 'hidden';
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                    });
                  }}
                >
                  {'Click to open file ' + attachmentFilename}
                </a>
              </When>
              <Otherwise>No pdf attached</Otherwise>
            </Choose>
            <br />
            <Button
              disabled={!file && (!hasAttachment || attachmentDeleted)}
              className="mt-3"
              kind="danger"
              onClick={onRemove}
            >
              <i className="fa fa-trash mr-1" />
              Remove
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  </Col>,
];

Attachment.propTypes = {
  hasAttachment: PropTypes.bool,
  file: PropTypes.object,
  attachmentDeleted: PropTypes.bool,
  onUpload: PropTypes.func,
  onRemove: PropTypes.func,
  downloadAttachment: PropTypes.func,
};

export default Attachment;



// WEBPACK FOOTER //
// src/components/reportContentLayout/Attachment/index.jsx